import { Flex, type FlexProps } from '@ironhack/design-system2/components/flex';
import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@ironhack/design-system2/components/tab';
import { type ReactElement } from 'react';

import { CancelWrap } from '@/app/components/server/cancel-wrap';
import { ProgressCard } from '../progress-card';
import { useModuleBackground } from '../progress';

type Props = {
  cards: ProgressCard[];
} & FlexProps;

export const ProgressCardTabs = (props: Props): ReactElement => {
  const { cards, ...flexProps } = props;
  const [progressFill] = useModuleBackground();

  return (
    <Flex {...flexProps}>
      <Tabs width="full">
        <CancelWrap below="md" withPadding>
          <TabList gap={3} overflowX="auto" whiteSpace="nowrap">
            {cards.map(({ tabTitle }, index) => (
              <Tab
                _selected={{
                  borderColor: 'fill.white',
                }}
                color="text.inverse"
                fontSize="m"
                key={`${tabTitle}-${index}`}
                textTransform="uppercase"
              >
                {tabTitle}
              </Tab>
            ))}
          </TabList>
        </CancelWrap>
        <TabPanels>
          {cards.map((card, index) => {
            const progressValue = Math.floor(
              (100 / cards.length) * (index + 1)
            );
            return (
              <TabPanel key={`${card.tabTitle}-${index}`} mt={3} p={0}>
                <ProgressCard
                  card={{ ...card, progressValue, progressFill }}
                  w="full"
                />
              </TabPanel>
            );
          })}
        </TabPanels>
      </Tabs>
    </Flex>
  );
};
